var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ForecastConfig_1;
import { ToolType } from '@symon-ai/wisepipe-base-pipe';
import { JSON, JsonDiscriminatorValue, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { BaseForecastConfig } from './baseForecastConfig';
import { ToolCategories } from './toolCategories';
import { ToolConfigInfo } from './toolConfigInfo';
import { forecastConfigSchemaValidation } from '../validations.generated';
export const FORECAST_MIN_OPTIONS = 1;
export const FORECAST_MAX_OPTIONS = 14;
export const forecastConfigSchema = {
    $id: 'urn:wisepipe-common-pipe:ForecastConfig',
    type: 'object',
    properties: {
        options: { type: 'integer', minimum: FORECAST_MIN_OPTIONS, maximum: FORECAST_MAX_OPTIONS }
    },
    required: ['options']
};
let ForecastConfig = ForecastConfig_1 = class ForecastConfig extends BaseForecastConfig {
    constructor(dateColumn, valueColumn, alias, periods, options, frequency, groupByColumns, ignoreLimit, isMultiVariate, staticAttributes, excludeColumns, smartExclude, performanceMeasureMethod, customFormats) {
        super(ToolType.FORECAST, dateColumn, valueColumn, alias, periods, frequency, groupByColumns, ignoreLimit, isMultiVariate, staticAttributes, excludeColumns, smartExclude, performanceMeasureMethod, customFormats);
        this.options = options;
        JSON.validate(this, ForecastConfig_1);
    }
    static get info() {
        return new ToolConfigInfo(ToolType.FORECAST.split('_')
            .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
            .join(' '), [ToolCategories.LEARN], this.ins, this.outs, [
            'forecast',
            'linear regression forecast',
            'arima forecast',
            'auto regressive forecast',
            'simple exp smoothing forecast',
            'prophet forecast',
            'seasonal arima forecast',
            'moving average forecast',
            'weighted moving average forecast',
            'exp smoothing forecast',
            'vector auto regressive forecast'
        ], false);
    }
};
ForecastConfig = ForecastConfig_1 = __decorate([
    JsonSchemaV2(forecastConfigSchema, forecastConfigSchemaValidation),
    JsonDiscriminatorValue(ToolType.FORECAST)
], ForecastConfig);
export { ForecastConfig };
//# sourceMappingURL=forecastConfig.js.map